var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Accounts'),_c('Activities'),_c('PointShop'),_c('Coupons'),_c('div',{staticClass:"text-center my-5"},[_c('Subscription')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }